import { BrandTypographyStyle } from "../../../models/brand.model.ts";
import { httpRequest } from "../../http";
import { BrandTypographyStyleFields, brandTypographyStylesUrl } from "./cmdGetBrandTypographyStyles";

export class CommandCreateBrandTypographyStyle {
    async run(organizationId: string, brandId: string, fields: BrandTypographyStyleFields): Promise<BrandTypographyStyle> {
        return await httpRequest<BrandTypographyStyle>(brandTypographyStylesUrl(organizationId, brandId), { method: "POST", body: fields });
    }
}
